<template>
	<pre v-html="$t('terms.agreement4')"></pre>
</template>

<script>
export default {
	name: 'Agreement4',
};
</script>

<style scoped></style>
